import DefaultModal from 'components/common/DefaultModal';
import CommonTransactionForm from 'components/CommonTransactionForm';
import React from 'react';
import { GeneralFunction } from 'types/common';
import { ILocation } from 'types/location';
import { ITransactionType } from 'types/services';
import { ITransaction } from 'types/transaction';

const TransactionModal: React.FC<{
  closeForm: any;
  visible?: boolean;
  transaction?: ITransaction;
  transactionTypes?: ITransactionType[];
  selectedTransactionType?: ITransactionType;
  locations?: ILocation[];
  fetchNextPageLocationData?: GeneralFunction;
}> = ({
  closeForm,
  visible,
  transaction,
  transactionTypes,
  selectedTransactionType,
  locations,
  fetchNextPageLocationData,
}) => (
  <DefaultModal
    props={{
      visible,
      title: 'Edit Transaction',
      onCancel: closeForm,
      destroyOnClose: true,
    }}>
    <CommonTransactionForm
      selectedTransactionType={selectedTransactionType}
      closeForm={closeForm}
      transaction={transaction}
      transactionTypes={transactionTypes}
      locations={locations}
      fetchNextPageLocationData={fetchNextPageLocationData}
    />
  </DefaultModal>
);

export default TransactionModal;
